import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import { ServiceName } from "../../../../../../constants";
import { COLORS, fontMixin, getColorByService } from "../../../../../../styles";

interface L_ContainerProps {
	$service: ServiceName;
}

export const L_Container = styled(motion.div)<L_ContainerProps>`
	width: 170px;
	height: 86px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 12px;

	${(props) => {
		const color = getColorByService(props.$service);

		return css`
			${L_Icon} {
				svg {
					path {
						stroke: ${color};
					}

					&#keys {
						path {
							&:nth-child(2),
							&:nth-child(4),
							&:nth-child(8),
							&:nth-child(10),
							&:nth-child(12) {
								fill: ${color};
							}
						}
					}
				}
			}

			${L_InstrumentText} {
				color: ${color};
			}
		`;
	}}
`;

export const L_Body = styled(motion.div)`
	display: flex;
	align-items: start;
	column-gap: 10px;
`;

export const L_Icon = styled(motion.div)`
	svg {
		width: 40px;
		height: 44px;
	}
`;

export const L_InstrumentText = styled(motion.div)`
	${fontMixin({ size: 18, weight: 700 })};
	color: ${COLORS.Gold};
`;

export const logotypeContainerVariants = {
	hidden: {
		opacity: 0,
		scale: 0.94,
		y: 0,
	},
	visible: {
		opacity: 1,
		scale: 1,
		y: 0,
		transition: {
			duration: 0.2,
			ease: [0.16, 1, 0.3, 1],
		},
	},
	exit: {
		opacity: 0,
		scale: 0.94,
		y: -8,
	},
};
